module.exports = __webpack_public_path__ + "img/icon-episode.26168f5d.svg";